const unauthorized = () => {
    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'app-name': localStorage.getItem('appName'),
        'webcms': true
    }
}


const authorized = () => {
    return {
        'Authorization': localStorage.getItem('authToken') || '',
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'app-name': localStorage.getItem('appName'),
        'webcms': true,
    };
}

export { unauthorized, authorized }